var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let EditableCard = class EditableCard extends Vue {
    constructor() {
        super(...arguments);
        // @Prop({ default: () => ({
        //   cancel: i18n.tc('editable_card_tooltip_cancel') || 'Cancel',
        //   save: i18n.tc('editable_card_tooltip_save') || 'Save',
        //   edit: i18n.tc('editable_card_tooltip_edit') || 'Edit',
        // }) })
        // #endregion
        // #region @Refs
        /**
        * ie.
        * @Ref()
        * readonly anotherComponent!: AnotherComponent
        */
        // #endregion
        // #region Class properties
        /**
        * ie.
        * protected isLoading = true;
        * * protected company: Company | null = null;
        */
        this.isLoading = false;
        this.isEditing = false;
        this.isFailed = false;
        this.isSuccess = false;
        // #endregion
        // #region @Watchers
        /**
        * ie.
        * @Watch('company')
        * protected companyChanged() {
        *  // console.log('Company Changed') ;
        * }
        */
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    /**
    * ie.
    * protected mounted(): void {
    *  // console.log('MyComponent has Mounted');
    * }
    */
    // #endregion
    // #region Class methods
    /**
    * ie.
    * protected toggleLoading(): void {
    *  this.isLoading = ! this.isLoading;
    * }
    */
    onEdit() {
        this.isEditing = !this.isEditing;
        this.$emit('isEditing', this.isEditing);
    }
    onSave() {
        this.isLoading = true;
        const event = {
            setSuccessState: (timeout) => this.setSuccessState(timeout),
            setFailedState: (timeout) => this.setFailedState(timeout),
        };
        this.$emit('save', event);
    }
    onCancel() {
        this.isEditing = !this.isEditing;
        this.$emit('isEditing', this.isEditing);
    }
    setSuccessState(timeout = 1000) {
        this.isLoading = false;
        this.isSuccess = true;
        setTimeout(() => {
            this.isSuccess = false;
            this.$emit('isEditing', this.isEditing);
        }, timeout);
        this.isEditing = false;
        this.$emit('save-success');
    }
    setFailedState(timeout = 1000) {
        this.isLoading = false;
        this.isFailed = true;
        setTimeout(() => {
            this.isFailed = false;
        }, timeout);
        this.$emit('save-failed');
    }
    // #endregion
    // #region Async methods
    /**
    * ie.
    * protected async fetchUserCompany(): Promise<void> {
    *  this.company = await new Company().filter({user: this.user.id}).all();
    * }
    */
    // #endregion
    // #region Getters & Setters
    /**
    * ie.
    * protected get companyName(): string {
    *  return this?.company.name || 'N/A';
    * }
    */
    get classes() {
        const classes = [];
        Object.keys(this.$attrs).forEach((attr) => {
            classes.push(`atabix-editable-card--${attr}`);
            delete this.$attrs[attr];
        });
        return classes.join(' ');
    }
    get hasTitle() {
        if (this.title) {
            return true;
        }
        if (this.$slots && this.$slots.title) {
            return this.$slots.title.some((slotInput) => !!slotInput.text || !!slotInput.data);
        }
        return false;
    }
    get isDisabled() {
        return this.disabled || false;
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], EditableCard.prototype, "title", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], EditableCard.prototype, "disabled", void 0);
EditableCard = __decorate([
    Component({})
], EditableCard);
export default EditableCard;
